import * as React from 'react';
import { TotalsContainer } from '../../Totals/containers/TotalsContainer.js';

const CartTotals = ({ isMiniCart  })=>/*#__PURE__*/ React.createElement(TotalsContainer, {
        className: "mini-cart-v2__totals",
        shouldShowSubTotal: true,
        shouldShowTotalDiscount: true,
        isMiniCart: isMiniCart
    })
;

export { CartTotals };
//# sourceMappingURL=CartTotals.js.map
